export default {
  header: {
    newValuation: "New Valuation",
    balances: "Balances",
    allCases: "All Cases",
    allDrafts: "All Drafts",
    language: "Language",
    languageChinese: "中文",
    languageEnglish: "English",
    profile: "Profile",
    logout: "Logout",
    unlocked: "Unlock Report",
    history: "History",
  },

  profile: {
    email: "Email",
    prepaidBalance: "Prepaid Balance",
    pocBalance: "POC Balance",
    startup: "Startup",
    patent: "Patent",
    team: "Team",
  },

  qa: {
    chatPlaceholder: "Please enter",
    tips: "Please enter the patent or company name you want to value",
    quickValuationReview: "Quick Valuation Review",
    cannotInput: "Cannot input when selected",
    unlockSuccess: "Unlock successful, report generation is in progress,预计需要30分钟。",
    unlockFailed: "Balance insufficient, please contact the administrator",
    unlockTips:
      "Valuation completed, you have {balance} paid points, {poc_balance} POC points, please select the section you want to unlock?",
    unlockCost: "Consume {cost} points",
    downloadReport: "Downloading report, please wait...",
    downloadCertificate: "Downloading certificate, please wait...",
    reportGenerating: "Report generating...",
    certificateGenerating: "Certificate generating...",

    reportResult: "Report result as follows",
    valuationResult: "Valuation result",
    reportTimeout: "Report generation timeout, please refresh the page later to view the result",
    unknownError: "Unknown error, please contact the administrator",
    confirmSubmit: "Confirm submit",
    cannotRecognize: "Cannot recognize, please re-enter!",
    noSelect: "Please select the section to unlock",

    caseSubmit: "Submit Valuation",
    submitSection: "Submit Section",
  },

  form: {
    valuationType: "Valuation Type",
    valuationTips: "Please select the valuation type",
    companyNameOrPatentId: "Company Name/Patent Number",
    companyNameOrPatentIdTips: "Please enter the company name/patent number",
    company: "Company",
    patent: "Patent",
  },

  searcch: {
    placeholder: "Please enter ID or draft name search",
    placeholder2: "Please enter ID or case name search",
  },

  table: {
    id: "ID",
    caseName: "Case",
    draftName: "Draft Name",
    status: "Status",
    action: "Action",
    createTime: "Create Time",
    noMore: "No more",
    pending: "Pending",
    executing: "Submitting",
    finished: "Finished",
    failed: "Failed",
    unknown: "Unknown",
  },

  common: {
    confirm: "Confirm",
    cancel: "Cancel",
    submit: "Submit",
    reset: "Reset",
    report: "Report",
    viewReport: "View Report",
    miniReport: "Mini Report",
    viewMiniReport: "View Mini Report",
    certificate: "Certificate",
    viewCertificate: "View Certificate",
    search: "Search",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    save: "Save",
    loading: "Loading...",
    success: "Success",
    error: "Error",
    warning: "Warning",
    info: "Info",
    unlock: "Unlock",
    downloadCompleted: "Download completed",
    downloadFailed: "Download failed",
    downloadCancelled: "Download cancelled",
    networkError: "Network error",
  },

  login: {
    title: "Login to OxValue.AI",
    email: "Email",
    enterEmail: "Enter Email",
    code: "Code",
    enterCode: "Enter Code",
    invitationCode: "Invitation Code (Optional)",
    enterInvitationCode: "Enter Invitation Code",
    loginButton: "Login",
    sendCode: "Send Code",
    resendCode: "Resend in {time} secs",
    errors: {
      codeError: "Please enter 4 digits code",
      loginError: "Wrong email or code！",
      emailRequired: "Please enter email",
      codeRequired: "Please enter code",
      invalidEmail: "Please enter a valid email",
    },
  },
};
